import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DbcOnboardV2RoutingModule} from './dbc-onboard-v2-routing.module';
import {DbcOnboardComponent} from './pages/onboard/dbc-onboard.component';
import {PostSignupComponent} from './pages/post-signup/post-signup.component';
import {DbcDesktopFormComponent} from './components/dbc-desktop-form/dbc-desktop-form.component';
import {DbcMobileFormComponent} from './components/dbc-mobile-form/dbc-mobile-form.component';
import {DbcOnboardV2Service, DbcAuth0LinkedInUserDetailsService} from './services/dbc-onboard-v2.service';
import {SsoAuthService} from '../global-services/sso-auth.service';
import {FormsModule} from '@angular/forms';
import {ImageCropperV2Module} from '../global-components/image-cropper-v2/image-cropper-v2.module';
import {DbcIndexedDbService} from '../global-services/indexed-db.service'
import {ColorPickerV2Module} from '../global-components/color-picker-v2/color-picker-v2.module';
import {FloatingLabelInputModule} from '../global-components/floating-label-input/floating-label-input.module';
import {BeaconstacModule} from 'kaizen-design-system';
import {WaitLoaderModule} from '../global-components/wait-loader/wait-loader.module';
import {ErrorScreenModule} from '../global-components/error-screen/error-screen.module';
import {EditImageModule} from '../global-components/edit-image/edit-image.module';
import {MessageModalModule} from '../shared/message-modal/message-modal.module';
import {BeaconstacMobileDrawerModule} from '../global-components/beaconstac-mobile-drawer/beaconstac-mobile-drawer.module';
import {CardScannerModule} from '../card-scanner/card-scanner.module';
import {ToastModule} from '../global-components/toast/toast.module';
import {ErrorMessageModalModule} from '../global-components/error-message-modal/error-message-modal.module';
import {ModalModule} from 'ngx-bootstrap/modal';
import { LinkedInLoaderComponent } from './components/linkedin-loader/linkedin-loader.component';
import {FormLayout1Component, InputStatePipe} from './components/form-layout-1/form-layout-1.component';

@NgModule({
    declarations: [
        DbcOnboardComponent,
        PostSignupComponent,
        DbcDesktopFormComponent,
        DbcMobileFormComponent,
        FormLayout1Component,
        LinkedInLoaderComponent,
        InputStatePipe
    ],
    imports: [
        CommonModule,
        DbcOnboardV2RoutingModule,
        FormsModule,
        ImageCropperV2Module,
        FloatingLabelInputModule,
        ColorPickerV2Module,
        BeaconstacModule,
        WaitLoaderModule,
        BeaconstacMobileDrawerModule,
        ErrorScreenModule,
        EditImageModule,
        MessageModalModule,
        ErrorScreenModule,
        WaitLoaderModule,
        CardScannerModule,
        ToastModule,
        ModalModule,
        MessageModalModule,
        ErrorMessageModalModule,
    ],
    providers: [
        DbcOnboardV2Service,
        DbcAuth0LinkedInUserDetailsService,
        SsoAuthService,
        DbcIndexedDbService
    ]
})
export class DbcOnboardV2Module { }
